import authStore, {
  authStoreKey,
  useAuthStore,
  AuthStore,
} from "@/stores/modules/auth";
import loginStore, {
  loginStoreKey,
  useLoginStore,
  LoginStore,
} from "@/stores/modules/login";
import resourceStore, {
  resourceStoreKey,
  useResource,
  ResourceStore,
} from "@/stores/modules/resource";
import { useEditStore, EditStore, IEditor } from "@/stores/modules/edit";
import { useUndoRedo, isRedo, isUndo, UndoRedo } from "@/stores/modules/undo";

export {
  AuthStore,
  LoginStore,
  ResourceStore,
  EditStore,
  IEditor,
  isUndo,
  isRedo,
  UndoRedo,
};
export default {
  authStoreKey,
  authStore,
  loginStoreKey,
  loginStore,
  resourceStoreKey,
  resourceStore,
  useAuthStore,
  useLoginStore,
  useResource,
  useEditStore,
  useUndoRedo,
};
